const ar = {
    "sc_title": "مركز الأمن",
    "sc_subtitle": "طبقة أمان مدمجة GaiaShield",
    "sc_tab_status": "🛡️ حالة الحماية",
    "sc_tab_events": "📋 سجل الأمن",
    "sc_tab_node": "⚙️ أمن العقدة",
    "sc_loading": "جاري تحميل بيانات الأمان...",
    "sc_status_secured": "حالة النظام: الحساب محمي",
    "sc_status_warning": "حالة النظام: تحذيرات نشطة",
    "sc_desc_secured": "لا توجد تحذيرات أمنية حرجة نشطة. GaiaShield يراقب حسابك بنشاط.",
    "sc_desc_warning": "تنبيه: هناك أحداث أمنية نشطة تتطلب انتباهك.",
    "sc_account_protection": "حماية الحساب",
    "sc_message_protection": "حماية الرسائل",
    "sc_audits": "تدقيق الأمن",
    "sc_active": "نشط",
    "sc_failed_logins": "تسجيلات دخول فشلت",
    "sc_tamper_checks": "فحوصات التلاعب",
    "sc_blocked_replays": "عمليات إعادة التشغيل المحظورة",
    "sc_last_check": "آخر فحص",
    "sc_just_now": "الآن فقط",
    "sc_open_warnings": "تحذيرات مفتوحة",
    "sc_btn_acknowledge": "تأكيد",
    "sc_filter_severity": "الخطورة",
    "sc_filter_category": "الفئة",
    "sc_filter_hide_ack": "إخفاء المؤكدة",
    "sc_btn_export": "تصدير",
    "sc_col_details": "التفاصيل",
    "sc_col_time": "الوقت",
    "sc_col_status": "الحالة",
    "sc_col_action": "الإجراء",
    "sc_no_events": "لم يتم العثور على أحداث أمنية.",
    "sc_node_title": "لوحة تحكم أمن مشغل العقدة",
    "sc_system_health": "صحة النظام",
    "sc_last_audit": "آخر تدقيق",
    "sc_packed_logs": "السجلات المجمعة",
    "sc_unconfirmed_events": "الأحداث غير المؤكدة",
    "sc_operator_action": "مطلوب إجراء من المشغل",
    "sc_all_ok": "كل شيء على ما يرام",
    "sc_critical_events": "أحداث النظام الحرجة",
    "ac_title": "مركز الحوكمة والإبلاغ عن المخالفات",
    "ac_subtitle": "إجماع الحوكمة وإساءة الاستخدام في GaiaCom",
    "ac_tab_my_reports": "بلاغاتي",
    "ac_tab_queue": "قائمة الانتظار للمراجعة",
    "ac_tab_operator": "مشغل العقدة",
    "ac_tab_transparency": "الاتحاد والشفافية",
    "ac_loading": "جاري تحميل البيانات...",
    "ac_reported_cases": "الحالات المبلغ عنها",
    "ac_no_reports": "لم تقم بتقديم أي بلاغات بعد.",
    "ac_case_details": "تفاصيل الحالة",
    "ac_appeal_submit": "تقديم استئناف",
    "ac_appeal_status": "حالة الاستئناف",
    "ac_appeal_reason": "سبب الاستئناف",
    "ac_appeal_statement": "بيان",
    "ac_btn_appeal": "إرسال الاستئناف",
    "ac_trusted_reviewer_queue": "قائمة مراجعي الحسابات الموثوق بهم",
    "ac_case_review": "مراجعة الحالة",
    "ac_review_category": "الفئة الموصى بها",
    "ac_review_severity": "الخطورة الموصى بها",
    "ac_review_action": "الإجراء الموصى به",
    "ac_review_reason": "سبب المراجع",
    "ac_btn_submit_review": "تقديم المراجعة",
    "ac_node_operator_dashboard": "لوحة مشغل العقدة",
    "ac_apply_action": "تطبيق الإجراء (تجاوز)",
    "ac_target_type": "نوع الهدف",
    "ac_target_id": "معرف الهدف (معرف العقدة أو معرف القناة)",
    "ac_suspend": "التعليق نشط",
    "ac_reason": "السبب الرسمي",
    "ac_btn_apply": "فرض الإجراء",
    "ac_transparency_title": "سجل التوافق والشفافية",
    "ac_transparency_desc": "إثباتات لقطات قابلة للعرض العام لجميع القنوات والهويات الخاضعة للإشراف.",
    "ac_btn_snapshot": "إنشاء لقطة للشفافية",
    "search_placeholder": "البحث في الرسائل حسب الموضوع، المرسل، النص...",
    "abuse_center_title": "مركز الإساءة",
    "abbrechen": "يلغي",
    "active_identities": "الهويات النشطة",
    "active_identity": "الهوية النشطة",
    "add_btn": "يضيف",
    "add_contact_title": "أضف جهة اتصال",
    "admin": "مسؤل",
    "adressbuch": "دليل",
    "aktiviert": "ممكّن",
    "an": "ل",
    "anonymous_sender": "مرسل مجهول",
    "antworten": "إجابة",
    "attachment_gaia_hint": "تظل مرفقات GaiaCOM مشفرة من طرف إلى طرف.",
    "attachment_smtp_hint": "يحظر SMTP القديم المرفقات القابلة للتنفيذ/الشبيهة بالبرنامج النصي ويحفظ رسائل البريد الإلكتروني باعتبارها غير آمنة.",
    "attachments": "المرفقات",
    "auffaellig": "ملحوظ",
    "auth_beta_notice": "مرحلة الاختبار التجريبي: يتم اختبار GaiaCOM بشكل نشط. قد تحدث أخطاء. تأمين البذور المهمة ومراجعة سير العمل السري بعناية.",
    "auth_btn_login": "تحميل الهوية وتسجيل الدخول",
    "auth_btn_register": "تسجيل وإنشاء التشفير",
    "auth_copied": "منقول",
    "auth_copy_seed": "نسخ البذور",
    "auth_generate_seed": "توليد البذور",
    "auth_headline": "GaiaCOM هو أول بروتوكول بريد إلكتروني ونظام اتصالات آمن الكم مصمم للبشرية.",
    "auth_kicker": "الاتصالات الآمنة بعد الكم",
    "auth_mnemonic": "عبارة ذاكري",
    "auth_mnemonic_placeholder": "12 كلمة مفصولة بمسافات...",
    "auth_password": "كلمة المرور",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "المفاتيح الخاصة لا تترك جهازك. يمكن للمستلمين المقصودين فقط فك تشفير المحتوى.",
    "auth_proof_gaiadata_desc": "المعرفة الصفرية: ستظل متحكمًا في بياناتك. يتم تصغير بيانات التعريف ولا يتم استخدامها كملف تعريف نص عادي.",
    "auth_proof_gaiadrop_desc": "يمكن للأشخاص الخارجيين إرسال رسائل نصية سرية إلى GaiaID الخاص بك بدون حساب.",
    "auth_proof_gaiaproof_desc": "تُظهر أدلة التسليم والنزاهة أنه لم يتم التلاعب بالنص المشفر والمرسل والطابع الزمني.",
    "auth_proof_gaiavault_desc": "تظل الملاحظات الخاصة وملاحظات الاسترداد وسجلات الأمان مشفرة محليًا.",
    "auth_proof_hybrid_desc": "Quantum Shield: التشفير المختلط مع ML-KEM وX25519 يحمي من هجمات اليوم ومخاطر التخزين الآن وفك التشفير لاحقًا.",
    "auth_secure_mail": "تأمين البريد الفيدرالي الكمي",
    "auth_subline": "GaiaCOM هو نظام اتصالات كمي آمن للبريد الإلكتروني والدردشة وغرف الأزمات وGaiaDrop وملفات الأمان المحلية. تبقى المفاتيح الخاصة على جهازك، ويتم تشفير المحتوى من طرف إلى طرف، ويمكن تصدير الأدلة بدون نص عادي.",
    "auth_success_btn": "قم بتسجيل الدخول الآن",
    "auth_success_text": "تم إنشاء حساب GaiaCOM الخاص بك. تم اشتقاق المفاتيح محليًا من البذور الخاصة بك ولم يتم تخزينها على الخادم.",
    "auth_success_title": "تم التسجيل بنجاح",
    "auth_tab_drop": "جايا دروب",
    "auth_tab_login": "تسجيل الدخول / الحساب",
    "auth_toggle_login": "الحساب موجود بالفعل",
    "auth_toggle_register": "إنشاء حساب جديد",
    "auth_usecase_text": "مناسب للمحامين والشركات والسلطات والصحفيين والمبلغين والقضايا الأمنية الخاصة.",
    "auth_usecase_title": "مصممة للاتصالات الحساسة",
    "auth_username": "اسم المستخدم",
    "auth_username_placeholder": "أدخل الاسم...",
    "auth_value_chat": "دردشة E2E",
    "auth_value_drop": "إسقاط آمن",
    "auth_value_mail": "البريد الآمن",
    "auth_value_rooms": "غرف جايا",
    "bestaetigen": "يتأكد",
    "bestaetigt": "مؤكد",
    "bio_status": "السيرة الذاتية / الحالة",
    "biography": "سيرة",
    "change_password_desc": "يغير كلمة مرور تسجيل الدخول من جانب الخادم. تظل عبارة الاسترداد المحلية الخاصة بك محمية بشكل منفصل بواسطة كلمة مرور المخزن/فتح القفل.",
    "change_password_menu_desc": "قم بتحديث كلمة مرور تسجيل الدخول إلى GaiaCOM.",
    "change_password_title": "تغيير كلمة المرور",
    "channel_id": "معرف القناة",
    "channel_name_label": "اسم القناة",
    "chat_deleted_hidden": "الدردشة محذوفة ومخفية.",
    "chat_input_placeholder": "أدخل رسالة آمنة...",
    "chat_start_hint": "ابدأ المحادثة! جميع رسائل الدردشة محمية كميًا ومشفرة بتقنية E2E.",
    "choose_avatar": "اختر الصورة الرمزية",
    "ciphertext_hash": "تجزئة النص المشفر",
    "clear_chat": "دردشة فارغة",
    "clear_for_everyone": "فارغة للجميع",
    "clear_for_me": "فارغة بالنسبة لي فقط",
    "click_to_write_mail": "انقر لكتابة بريد إلكتروني",
    "click_top_right": "انقر في أعلى اليمين",
    "close": "يغلق",
    "code_kopieren": "نسخ الرمز",
    "code_kopieren_success": "تم نسخ الكود",
    "confirm_clear_channel_desc": "هل تريد مسح هذه القناة من العرض المحلي الخاص بك؟",
    "confirm_clear_channel_title": "قناة فارغة",
    "confirm_clear_chat": "هل تريد إفراغ هذه الدردشة؟",
    "confirm_clear_chat_desc": "هل تريد إفراغ هذه الدردشة؟",
    "confirm_clear_chat_title": "دردشة فارغة",
    "confirm_clear_everyone": "هل تريد إفراغ الدردشة لكلا الشريكين؟ (موافق = للجميع، إلغاء = لي فقط)",
    "confirm_delete_everyone": "هل تريد حذف الرسالة لكلا الشريكين؟ (موافق = للجميع، إلغاء = لي فقط)",
    "confirm_delete_msg": "هل تريد حذف هذه الرسالة؟",
    "confirm_delete_msg_desc": "هل تريد حذف رسالة الدردشة هذه؟",
    "confirm_delete_msg_title": "حذف الرسالة",
    "confirm_new_password": "تأكيد كلمة المرور الجديدة",
    "copy": "ينسخ",
    "create_btn": "يخلق",
    "create_channel_title": "إنشاء قناة",
    "create_group_is_crisis": "وضع علامة كمنطقة أزمة",
    "create_group_title": "إنشاء مجموعة جديدة",
    "crypto_lock_desc": "التحكم عندما يقوم GaiaCOM بإزالة مفاتيح التشفير المحلية من الذاكرة.",
    "crypto_lock_menu_desc": "التحكم في إعادة التحميل ومؤقتات عدم النشاط.",
    "crypto_lock_title": "قفل التشفير",
    "crypto_session_duration": "مقفلة بعد إعادة التحميل",
    "crypto_session_duration_desc": "يُبقي جلسة التشفير مفتوحة في علامة تبويب المتصفح هذه فقط للمدة المحددة.",
    "cryptographic_fingerprint": "بصمة التشفير",
    "current_password": "كلمة المرور الحالية",
    "data_minimization": "التقليل من البيانات",
    "decrypt_failed": "غير قابلة للفك",
    "delete": "يمسح",
    "delete_account_button": "حذف الحساب بشكل نهائي",
    "delete_account_confirm_label": "أدخل حذف للتأكيد",
    "delete_account_confirmation_error": "مطلوب كلمة المرور وتأكيد الحذف.",
    "delete_account_desc": "يقوم هذا الوضع بتدمير حسابك وهوياتك وجلسات جهازك وبيانات GaiaDrop وتحميل البيانات التعريفية والرسائل المنسوبة من جانب الخادم بشكل دائم.",
    "delete_account_done_desc": "تم حذف جميع بيانات GaiaCOM القابلة للتخصيص.",
    "delete_account_done_title": "تم حذف الحساب",
    "delete_account_menu_desc": "تدمير الحساب والبيانات المرتبطة به.",
    "delete_account_not_authenticated": "لا يوجد حساب نشط.",
    "delete_account_title": "حذف الحساب",
    "delete_for_everyone": "الحذف للجميع",
    "delete_for_me": "حذف فقط بالنسبة لي",
    "device_current": "هذا الجهاز",
    "device_last_seen": "آخر",
    "device_logout": "تسجيل الخروج",
    "device_sessions_desc": "تحقق من الجلسات النشطة وقم بإلغاء تسجيل الأجهزة التي لم تعد تثق بها.",
    "device_sessions_empty": "لم يتم العثور على أي أجهزة.",
    "device_sessions_menu_desc": "إدارة وإنهاء الجلسات النشطة.",
    "device_sessions_title": "الأجهزة المسجلة",
    "device_since": "منذ",
    "display_name": "اسم العرض",
    "drop_address_copied": "تم نسخ عنوان GaiaDrop.",
    "drop_btn_decrypting": "جارٍ فك تشفير البريد الوارد...",
    "drop_btn_load": "قم بتحميل صندوق الوارد لـ GaiaDrop",
    "drop_delete_desc": "هل تريد حقًا حذف هذا الإسقاط نهائيًا؟",
    "drop_delete_title": "حذف جايا دروب",
    "drop_desc": "قناة إسقاط المعرفة الصفرية النصية فقط للإشعارات الخارجية والإفصاح المسؤول والتقارير السرية. يمكن للأطراف الخارجية إرسال رسائل بدون حساب باستخدام GaiaID الخاص بك.",
    "drop_empty": "لم يتم تحميل رسائل GaiaDrop حتى الآن.",
    "drop_id": "معرف الإسقاط:",
    "drop_own_address": "عنوان GaiaDrop الخاص بك",
    "drop_proof": "مقاومة للسقوط",
    "drop_title": "GaiaDrop صندوق الوارد الآمن",
    "dunkler_modus": "الوضع المظلم",
    "e2e_chat_room_open": "افتح غرفة الدردشة E2E",
    "edit_profile": "تحرير الملف الشخصي",
    "edit_profile_desc": "تخصيص اسم العرض والسيرة الذاتية والصورة الرمزية.",
    "einladungscode": "رمز الدعوة",
    "enter_fingerprint_chars_confirm": "أدخل أحرف بصمة الإصبع المطلوبة للتأكيد.",
    "envelope_hash": "تجزئة المغلف",
    "erasability": "قابلية المسح",
    "erfolg": "نجاح",
    "exclude_plaintext": "تصدير بدون نص عادي",
    "export_disclosure": "حالة أمان التصدير",
    "export_package_desc": "قم بتضمين نص عادي فقط إذا كان هذا الكشف مقصودًا عن قصد.",
    "export_package_title": "حزمة أمان التصدير",
    "fehler": "خطأ",
    "gaiacom_reader": "قارئ جاياكوم",
    "gaiadrop_inbox_title": "غايا دروب البريد الوارد",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "يقوم GaiaCOM بتقليل البيانات التعريفية، والحفاظ على المفاتيح الخاصة محليًا، وتشفير المحتوى من البداية إلى النهاية، وتمكين الحذف الكامل للحساب.",
    "gdpr_home_title": "متوافق مع اللائحة العامة لحماية البيانات بنسبة 100%",
    "gdpr_reason_delete": "يؤدي حذف الحساب إلى إزالة الحساب والهويات والجلسات المحلية والبيانات القابلة للتخصيص من جانب الخادم.",
    "gdpr_reason_e2ee": "يظل المحتوى الخاص قابلاً لفك التشفير للمستلمين المقصودين فقط.",
    "gdpr_reason_minimal": "يتم استخدام البيانات التعريفية فقط للتوجيه والتسليم وبيانات اعتماد الأمان.",
    "gdpr_reason_zero_knowledge": "تظل المفاتيح الخاصة وبيانات الاسترداد تحت سيطرة المستخدم محليًا.",
    "gesendet": "مرسل",
    "gesperrt_verdaechtig": "محظور / مشبوه",
    "group_delete_desc": "هل تريد حقًا حذف هذه المجموعة نهائيًا؟ سيتم حذف جميع القنوات والرسائل في هذه المجموعة.",
    "group_delete_title": "حذف المجموعة",
    "group_description": "وصف",
    "group_icon_label": "رمز المجموعة / الصورة الرمزية",
    "group_name": "اسم المجموعة",
    "group_settings_avatar": "الصورة الرمزية",
    "group_settings_desc": "وصف",
    "group_settings_is_crisis": "وضع علامة كمنطقة أزمة",
    "group_settings_name": "اسم المجموعة",
    "group_settings_title": "إعدادات المجموعة",
    "groups_empty_desc": "قم بإنشاء مساحة عمل آمنة للمشروع أو الأزمات أو التواصل مع الفريق.",
    "groups_empty_title": "لا توجد محادثات جماعية حتى الآن",
    "gruppe_beitreten": "انضمت للمجموعة",
    "gruppe_erstellen": "+ إنشاء مجموعة",
    "gruppe_verlassen": "اترك المجموعة",
    "gruppen_chats": "محادثات جماعية",
    "heller_modus": "وضع مشرق",
    "how_to_receive_drops": "كيف يمكنني الحصول على قطرات؟",
    "identitaets_assistent": "مساعد الهوية",
    "inactivity_lock_duration": "القفل عندما يكون غير نشط",
    "inactivity_lock_duration_desc": "بعد هذه الفترة من عدم الإدخال، سيتم قفل GaiaCOM تلقائيًا بالتشفير.",
    "inactivity_lock_notice": "تم حظر GaiaCOM تشفيرًا بسبب عدم النشاط.",
    "include_plaintext": "تضمين نص عادي",
    "invite_code_label": "رمز الدعوة",
    "join_group_title": "انضم إلى المجموعة",
    "kanaele": "القنوات",
    "kanal_erstellen": "+ قناة",
    "kein_chat_ausgewaehlt": "لم يتم تحديد أي دردشة",
    "kein_kanal_ausgewaehlt": "لم يتم تحديد أي قناة",
    "keine_gruppe_ausgewaehlt": "لم يتم تحديد أي مجموعة",
    "keine_mails": "لا توجد رسائل بريد إلكتروني متاحة.",
    "key_change_warn_desc": "لقد تغير المفتاح العام لجهة الاتصال هذه. تحقق من بصمة الإصبع قبل الوثوق بها.",
    "key_change_warn_title": "تحذير التشفير",
    "key_change_warning_changed": "لقد تغير. قد يكون هذا علامة على هجوم رجل في الوسط!",
    "key_change_warning_msg": "مفتاح الهوية لجهة الاتصال",
    "key_transparency": "الشفافية الرئيسية",
    "kopiert": "منقول",
    "kryptographische_schluessel": "مفاتيح التشفير",
    "kryptographische_schluessel_desc": "إظهار المفاتيح الخاصة والعبارة الأولية الاحتياطية.",
    "laden": "حمولة...",
    "leeren": "فارغ",
    "loading": "حمولة...",
    "local_key_vault": "قبو المفتاح المحلي",
    "local_keys_label": "المفاتيح المحلية",
    "lock_on_reload": "القفل دائمًا بعد إعادة التحميل",
    "logout": "تسجيل الخروج",
    "mail_compose": "اكتب البريد الإلكتروني",
    "mein_profil": "ملفي الشخصي",
    "melden": "تقرير",
    "menu": "قائمة طعام",
    "message": "أخبار",
    "message_id": "معرف الرسالة",
    "message_pin": "دبوس",
    "message_pinned_title": "الرسائل المثبتة",
    "message_react": "رد فعل",
    "message_reply": "إجابة",
    "message_replying_to": "الإجابة على",
    "message_save": "يحفظ",
    "message_saved": "أنقذ",
    "message_to_channel": "رسالة إلى",
    "message_unpin": "يحل",
    "message_unsave": "لا تحفظ",
    "mitglied": "عضو",
    "mitglieder": "أعضاء",
    "ml_kem": "مل-كيم",
    "neue_mail": "البريد الإلكتروني الجديد",
    "never_auto_lock": "أبدا تلقائيا",
    "new_fingerprint": "بصمة جديدة",
    "new_identity": "هوية جديدة",
    "new_password": "كلمة المرور الجديدة",
    "no_description": "لا يوجد وصف",
    "no_key_history": "لم يتم تسجيل أي سجل رئيسي.",
    "no_specification": "غير محدد",
    "old_fingerprint": "بصمة قديمة",
    "open_privacy_imprint": "فتح بصمة وحماية البيانات",
    "post_quantum_e2e": "ما بعد الكم E2E",
    "posteingang": "البريد الوارد",
    "powered_by": "مدعوم من",
    "privacy_imprint_menu_desc": "عرض اللائحة العامة لحماية البيانات وحماية البيانات والإشعار القانوني.",
    "privacy_imprint_profile_desc": "تقوم GaiaCOM بمعالجة محتوى الاتصال وفقًا لمبادئ تقليل البيانات والتشفير الشامل والتحكم في المفاتيح المحلية.",
    "privacy_imprint_title": "حماية البيانات والإشعار القانوني",
    "profil": "حساب تعريفي",
    "profile_details": "تفاصيل الملف الشخصي",
    "profile_settings_hint": "يتم عرض إعدادات الملف الشخصي في اللوحة اليمنى.",
    "profile_unlock_desc": "لأسباب أمنية، يجب عليك إعادة إدخال كلمة المرور الخاصة بك لعرض مفاتيح التشفير الخاصة بك.",
    "proof_hash": "تجزئة الإثبات:",
    "public_drop_desc": "Secure Drop للحصول على معلومات نصية خارجية بدون حساب GaiaCOM.",
    "public_drop_message": "أخبار",
    "public_drop_message_placeholder": "أدخل نصًا سريًا...",
    "public_drop_send": "أرسل غايا دروب",
    "public_drop_sender": "ملاحظة المرسل اختيارية",
    "public_drop_sender_placeholder": "الاسم ورقم الملف أو مجهول",
    "public_drop_target": "الهدف GaiaID",
    "quanten_chat": "الدردشة الكمومية",
    "quantum_secure_exchange": "التبادل الكمي الآمن عبر...",
    "quantum_secure_net": "الشبكة الآمنة الكمومية GaiaCOM (Ed25519 وML-KEM)",
    "quantum_shield_desc": "تحمي شبكة GaiaCOM خصوصيتك من خلال بروتوكول تشفير هجين متعدد الطبقات محمي ضد الهجمات من أجهزة الكمبيوتر الكمومية المستقبلية.",
    "quantum_shield_l1_desc": "يستخدم معيار FIPS 203 لتغليف مفتاح مشترك متماثل. يمنع التسجيل السلبي وفك التشفير لاحقًا (\\",
    "quantum_shield_l1_title": "1. الحماية بعد الكم (ML-KEM-1024)",
    "quantum_shield_l2_desc": "إجراء تبادل مفاتيح Diffie-Hellman كلاسيكي وسريع للغاية يعمل كطبقة إضافية من الأمان في الإجراء المختلط.",
    "quantum_shield_l2_title": "2. تشفير المنحنى الإهليلجي (X25519)",
    "quantum_shield_l3_desc": "يتم توقيع كل رسالة وكل مظروف اتحادي بشكل مشفر للتحقق بشكل لا لبس فيه من صحة المرسل.",
    "quantum_shield_l3_title": "3. التوقيعات الرقمية (Ed25519)",
    "quantum_shield_l4_desc": "يقوم بتشفير محتوى الرسالة بشكل متماثل وربط المرسل والمستلم وبيانات التعريف بشكل متماثل وإحكام في البيانات الإضافية المصادق عليها (AAD) لمنع هجمات إعادة التشغيل.",
    "quantum_shield_l4_title": "4. مصادقة AAD (AES-256-GCM)",
    "quantum_shield_status": "حالة الدرع الكمي",
    "receive_drops_step1": "قم بمشاركة GaiaID الخاص بك (على سبيل المثال، باستخدام زر النسخ أعلاه) مع مصادر خارجية.",
    "receive_drops_step2": "يقوم ذلك باستدعاء صفحة تسجيل الدخول الخاصة بمثيل GaiaCOM الخاص بك والتبديل إلى علامة التبويب",
    "receive_drops_step3": "وإرسال رسالتهم المشفرة إلى عنوانك.",
    "receiver_gaia": "جهاز استقبال جاياكوم",
    "receiver_smtp": "مستلم SMTP",
    "records_stored": "تم حفظ السجلات",
    "refresh": "تحديث",
    "report_abuse_desc": "هل تريد الإبلاغ عن هذه الرسالة وإرسال دليل مشفر لإساءة الاستخدام إلى الخادم؟",
    "report_abuse_title": "الإبلاغ عن إساءة الاستخدام",
    "reputation_status": "حالة السمعة",
    "room_chat_start_hint": "ابدأ المحادثة! جميع الرسائل في قناة المجموعة هذه مشفرة بتقنية E2E لا مركزية وآمنة كميًا.",
    "room_policy_audit": "مسار التدقيق وتناوب المفاتيح نشط.",
    "room_policy_crisis": "غرفة الأزمات",
    "room_policy_e2ee": "مساحة المعرفة صفر. E2EE آمن الكم.",
    "room_policy_title": "إرشادات الغرفة",
    "room_policy_zero_knowledge": "سياسة",
    "room_security_note_desc": "يتم التحقق من صحة جميع التغييرات الرئيسية عبر Key Transparency. استخدم GaiaVault لسجلات النسخ الاحتياطي الخاصة.",
    "room_security_note_title": "مذكرة أمنية مثبتة",
    "save_profile": "حفظ الملف الشخصي",
    "schluessel_entsperrt": "🔑 قفل المفتاح مرة أخرى",
    "search_gaia_label": "ابحث عن عنوان غايا",
    "security_warning_title": "تحذير أمني",
    "select_channel_chat": "حدد قناة من الشريط الجانبي الأيسر للدردشة.",
    "select_contact_chat": "حدد جهة اتصال من اللوحة اليمنى لبدء محادثة E2E آمنة الكم.",
    "select_mail_read": "حدد بريدًا إلكترونيًا من القائمة لقراءة محتواه الآمن أو إنشاء رسالة جديدة.",
    "senden": "يرسل",
    "sender_signature": "توقيع المرسل",
    "server_log": "سجل الخادم:",
    "server_received": "تم استلام الخادم",
    "session_lock": "قفل الجلسة",
    "setup_address_keys": "إنشاء عنوان ومجموعة المفاتيح",
    "setup_profile": "إعداد في الملف الشخصي",
    "smtp_inbox_title": "استقبال SMTP",
    "smtp_legacy_badge": "SMTP قديم/غير آمن",
    "smtp_mode_option": "جسر SMTP القديم",
    "smtp_security_warning": "تم إرسال هذا البريد الإلكتروني عبر بروتوكول SMTP الكلاسيكي غير المشفر. لا يوجد تشفير شامل نشط.",
    "smtp_security_warning_desc": "هذه الرسالة تغادر غرفة أمان GaiaCom. لا يوفر تسليم SMTP ضمان GaiaCom الأصلي الشامل، ولا ضمان TrustMesh ولا ضمان Godmode من البوابة.",
    "spam_verdacht": "البريد المزعج / الشك",
    "spam_warning_desc": "تحتوي هذه الرسالة على إشارات سمعة مشبوهة.",
    "spam_warning_title": "تحذير من البريد العشوائي",
    "speichern": "يحفظ",
    "sperren": "قفل",
    "standard_group_status": "دردشة جماعية قياسية (مشفرة E2EE)",
    "status": "حالة",
    "subject": "متعلق",
    "suchen": "ابحث عن عنوان Gaia جديد...",
    "tage": "أيام",
    "time_unknown": "الوقت غير معروف",
    "transmission_mode": "وضع النقل",
    "trust_age": "عمر الثقة",
    "trust_passport_title": "جواز سفر الثقة",
    "unbestaetigt": "غير مؤكد",
    "unknown_sender": "مجهول",
    "unlock_btn": "فتح",
    "unlock_btn_profile": "فتح",
    "unlock_desc": "يتم تخزين ملف المفتاح الخاص الخاص بك بشكل مشفر. أدخل كلمة المرور الخاصة بك لتحميل مفاتيح التشفير في الذاكرة فقط.",
    "unlock_logout": "تسجيل الخروج وإغلاق المفاتيح المحلية",
    "unlock_title": "فتح الهوية",
    "untrusted": "غير جدير بالثقة",
    "update_password": "تحديث كلمة المرور",
    "upload_avatar_btn": "تحميل الصورة (معقمة)",
    "vault_btn_encrypt": "تشفير السجل",
    "vault_btn_lock": "قفل آمن",
    "vault_btn_unlock": "فتح آمنة",
    "vault_copied_success": "تم النسخ إلى الحافظة",
    "vault_decrypted_content": "المحتوى الذي تم فك تشفيره",
    "vault_desc": "قبو محلي مشفر للنسخ الاحتياطية للاسترداد وملاحظات الهوية والوصول إلى الخادم وجهات اتصال الطوارئ والملاحظات القانونية والأحداث الأمنية والسجلات الخاصة.",
    "vault_empty": "لم يتم حفظ أي سجلات آمنة حتى الآن.",
    "vault_locked_pane_notice": "آمنة مقفلة. يرجى فتح على اليمين.",
    "vault_new_record": "سجل آمن جديد",
    "vault_pwd_placeholder": "أدخل كلمة مرور المخزن...",
    "vault_record_body": "سجل المحتوى",
    "vault_record_body_placeholder": "أدخل محتوى السجل المشفر...",
    "vault_record_category": "فئة",
    "vault_record_title": "عنوان السجل",
    "vault_record_title_placeholder": "عنوان السجل الآمن",
    "vault_title": "سجلات GaiaVault الآمنة",
    "verify_new_fingerprint_hint": "تحقق من بصمة الإصبع الجديدة قبل قبول المفتاح.",
    "vertrauenswuerdig": "جدير بالثقة",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "من",
    "warnung": "تحذير",
    "wizard_address": "عنوان",
    "wizard_back": "خلف",
    "wizard_check1": "لقد أنقذت بذوري بأمان.",
    "wizard_custom_domain": "استخدم المجال الخاص بك",
    "wizard_desc1": "لا يقوم GaiaCOM بتخزين المفاتيح الخاصة على جانب الخادم. بدون بذور ذاكري، لا يمكن لأحد استعادة الرسائل المفقودة.",
    "wizard_desc2": "يحدد عنوانك العقدة الموحدة التي يتم من خلالها توجيه المغلفات المشفرة.",
    "wizard_fallback": "العقد الاحتياطية",
    "wizard_finish": "الإعداد الكامل",
    "wizard_next": "إضافي",
    "wizard_server_domain": "مجال عقدة الخادم",
    "wizard_step1": "1. البذور الاحتياطية",
    "wizard_step2": "2. العنوان والخادم",
    "wizard_title1": "عمل نسخة احتياطية من مفتاح الاسترداد",
    "wizard_title2": "حدد عنوان GaiaCOM",
    "write_message_placeholder": "اكتب رسالة آمنة...",
    "you": "أنت",
    "zero_knowledge": "المعرفة صفر",
    "zero_knowledge_encryption": "تشفير المعرفة الصفرية",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "Die Chat-Nachricht wurde lokal aus deiner Inbox entfernt.",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "أنا مسؤول عن الحفاظ على أمان بيانات الوصول الخاصة بي.",
    "wizard_check_is_beta": "أدرك أن GaiaCom هو برنامج تجريبي.",
    "wizard_check_no_illegal": "لن أستخدم GaiaCom لأغراض غير قانونية.",
    "wizard_check_no_uptime": "أنا أفهم أنه لا يوجد ضمان للتوافر.",
    "wizard_check_smtp_security": "أدرك أن رسائل SMTP لا توفر الأمان الكامل لـ GaiaCom.",
    "wizard_check_terms_read": "لقد قرأت شروط خدمة النسخة التجريبية.",
    "wizard_step_terms": "شروط الاستخدام",
    "wizard_terms_text": "شروط استخدام GaiaCom واتفاقية الاختبار التجريبي (المرحلة التجريبية)\n\nالموفر: VisionGaiaTechnology (يشار إليه فيما يلي باسم \"المزود\")\nالحالة: مرحلة الاختبار التجريبي العام\nالصلاحية: من 21 يونيو 2026\n\n⚠️ أهم ملاحظة مقدمًا (يرجى القراءة بعناية)\nGaiaCom في مرحلة الاختبار التجريبي العام. على الرغم من التدابير الأمنية الشاملة، لا يمكن ضمان التحرر من الأخطاء أو التوفر المستمر أو الأمان المطلق للبرنامج والبنية التحتية الأساسية. استخدم على مسؤوليتك الخاصة. يتحمل المستخدمون مسؤولية التخزين الآمن لبيانات الوصول الخاصة بهم (خاصة مفاتيح GaiaVault) والالتزام بالقوانين المعمول بها.\n\n1. موضوع وغرض مرحلة الاختبار التجريبي\n1.1. الغرض من توفيرها: GaiaCom هي خدمة بريد إلكتروني ودردشة جديدة تعتمد على التشفير ما بعد الكمي (PQC). إن التوفير أثناء المرحلة التجريبية مخصص حصريًا للاختبار الفني ومحاكاة التحميل والعثور على أخطاء البرنامج (الأخطاء) وتحسين سهولة الاستخدام.\n1.2. حالة النسخة التجريبية: يدرك المستخدم أن البرنامج المعروض هو إصدار أولي (برنامج تجريبي). لم يتم تطوير هذا بشكل كامل من الناحية الفنية بعد، ولا يفي بمعايير المنتج النهائي التجاري ويمكن أن يسبب أخطاء أو فقدان البيانات أو تأخير الإرسال أو تعطل النظام.\n1.3. عدم الحق في الاستمرار: يحق للمزود في أي وقت إيقاف الخدمة كليًا أو جزئيًا، أو تغيير الوظائف أو تقييدها أو إزالتها بشكل مؤقت أو دائم دون إبداء الأسباب.\n\n2. التوفر وإخلاء المسؤولية عن الضمان\n2.1. ضمان عدم التوفر: يتم توفير GaiaCom دون أي ضمان للتوفر أو وقت التشغيل. ليس هناك حق في توفر الخدمة دون انقطاع.\n2.2. استبعاد الضمان: يتم توفير البرنامج في حالته الحالية (\"كما هو\") ويخضع لمدى توفره. إلى الحد الذي يسمح به القانون، يتم استبعاد أي مطالبات ضمان بخصوص العيوب المادية والقانونية في البرنامج. وعلى وجه الخصوص، ليس هناك ما يضمن أن البرنامج خالٍ من الأخطاء أو البرامج الضارة أو مناسب لغرض معين.\n\n3. إدارة المخاطر والتزامات المستخدم\n3.1. حظر تخزين البيانات الهامة: يتعهد المستخدم بعدم تخزين أو نقل أي بيانات مهمة للأعمال أو حيوية أو ضرورية من الناحية التشغيلية أو حساسة بشكل خاص من الناحية القانونية عبر GaiaCom حصريًا (مثل ملفات المرضى أو البيانات المالية شديدة الحساسية أو الأسرار المنظمة رسميًا). لا يجوز استخدام الخدمة للبنية التحتية حيث يمكن أن تؤدي حالات الفشل غير المتوقعة إلى إصابة شخصية أو تلف في الممتلكات أو خسارة مالية كبيرة.\n3.2. النسخ الاحتياطي المسؤول ذاتيًا: يكون المستخدم مسؤولاً عن النسخ الاحتياطي لجميع البيانات الواردة أو المرسلة عبر GaiaCom والتي يحتاجها على المدى الطويل على أنظمته المستقلة (النسخ الاحتياطية). لا يضمن المزود التخزين الدائم أو إمكانية استعادة البيانات على خوادمه.\n\n4. ميزات التشفير وGaiaVault\n4.1. التشفير ما بعد الكمي (PQC): تطبق GaiaCom أحدث عمليات التشفير الموجهة نحو المستقبل والتي تم تصميمها لمقاومة الهجمات من أجهزة الكمبيوتر الكمومية المستقبلية. ومع ذلك، يدرك المستخدم أن هذا مجال علمي ديناميكي وجديد. ولا يمكن ضمان الأمن المطلق الذي لا يمكن دحضه على أساس الحالة الراهنة للعلم والتكنولوجيا. المصطلحات مثل \"آمن بنسبة 100%\" أو \"غير قابل للاختراق\" أو \"آمن عسكريًا\" غير مضمونة صراحةً.\n4.2. لا يوجد ضمان استرداد (GaiaVault): تعتمد GaiaCom على مفهوم أمان ثابت للمعرفة الصفرية. تظل شرائح التشفير وبيانات الوصول تحت سيطرة المستخدم فقط (مؤمنة عبر GaiaVault).\nهام: إذا فقد المستخدم كلمات المرور أو عبارات المرور أو المفاتيح الخاصة أو بذور الاسترداد، فلن يكون لدى الموفر القدرة الفنية على إعادة بناء هذه البيانات أو إعادة تعيينها. يؤدي فقدان بيانات الوصول هذه حتماً إلى فقدان الوصول إلى حساب المستخدم وجميع البيانات المشفرة فيه بشكل لا رجعة فيه.\n4.3. لم يتم تدقيقه بالكامل بعد: يخضع البرنامج بشكل مستمر لفحوصات الأمان الداخلية، ولكن في وقت هذه المرحلة التجريبية، لم يخضع بعد لتدقيق أمني خارجي نهائي وشامل من قبل هيئات اختبار مستقلة.\n\n5. الواجهات والبروتوكولات القديمة والاتحاد\n5.1. ملاحظة على جسر SMTP: يوفر GaiaCom القدرة على الاتصال عبر بروتوكولات البريد الإلكتروني الكلاسيكية (مثل SMTP). يدرك المستخدم أن الرسائل التي تغادر منطقة أمان GaiaCom الأصلية (على سبيل المثال عند إرسالها إلى عنوان @gmail.com أو @gmx.de تقليدي) يتم نقلها عبر خوادم غير مشفرة أو خوادم تابعة لجهات خارجية. تنطبق ضمانات GaiaCom الأمنية الشاملة على نطاق محدود فقط أو لا تنطبق على الإطلاق على هذه الرسائل القديمة الصادرة أو الواردة خارجيًا.\n5.2. ملاحظة اتحادية: إذا كانت GaiaCom تعمل على شبكة اتحادية، فقد تمر الرسائل والبيانات عبر خوادم خارجية. بينما تظل محتويات الرسائل محمية بالتشفير الشامل، فإن البيانات الوصفية (مثل وقت الإرسال وعناوين IP للخوادم المعنية وعناوين المستلمين) قد تكون مرئية تقنيًا لمشغلي هذه الخوادم الموحدة. ليس للموفر أي تأثير على ممارسات حماية البيانات لمشغلي خوادم الطرف الثالث في الشبكة الموحدة.\n\n6. الاستخدامات المقبولة والأنشطة المحظورة\nيتعهد المستخدم بعدم استخدام الخدمة بشكل غير صحيح أو لأغراض غير قانونية. ويحظر على وجه الخصوص ما يلي:\n- توزيع أو إرسال أو استضافة الفيروسات أو البرامج الضارة أو محتوى التصيد أو البرامج الضارة الأخرى.\n- استخدام الخدمة لتنفيذ هجمات رفض الخدمة (DDoS) أو إرسال بريد جماعي غير مرغوب فيه (البريد العشوائي).\n- إساءة استخدام النظام لارتكاب عمليات احتيال.\n- توزيع أو تبادل محتوى غير قانوني، ولا سيما تصوير الاعتداء الجنسي على الأطفال (CSAM)، أو الدعاية الإرهابية، أو الدعوات إلى العنف أو أي محتوى آخر ذي صلة جنائية.\n\n7. نظام الإبلاغ عن إساءة الاستخدام\n7.1. الإبلاغ عن السلوك المسيء: لدى المستخدمين الفرصة للإبلاغ عن الاتصالات المسيئة أو الأنشطة غير القانونية عبر نظام الإساءة المتكامل.\n7.2. معالجة التقارير: من أجل ضمان الحماية ضد سوء الاستخدام، يمكن تحليل التقارير الواردة تقنيًا (مع الحفاظ على حدود الخصوصية والتشفير). يمكن أن يؤدي ذلك إلى تعليق مؤقت أو دائم لحسابات المستخدمين أو عناوين IP في حالة ثبوت حدوث انتهاكات لشروط الاستخدام هذه.\n\n8. حدود المسؤولية\n8.1. معيار المسؤولية: يتم توفير البرنامج التجريبي مجانًا. وفقا للقواعد القانونية للتبرعات أو القروض، فإن مقدم الخدمة مسؤول فقط عن النية (الضرر المتعمد) والإهمال الجسيم.\n8.2. استبعاد المسؤولية عن فقدان البيانات: يتم استبعاد المسؤولية عن فقدان البيانات ما لم تكن الخسارة ناجمة عن قصد أو من خلال الإهمال الجسيم من جانب المزود وكان المستخدم قد أوفى بالتزامه بتخفيف الضرر من خلال النسخ الاحتياطية المنتظمة (خارج GaiaCom).\n8.3. الحدود القانونية: لا تنطبق حدود المسؤولية المذكورة أعلاه على الضرر الذي يلحق بالحياة أو الجسد أو الصحة أو المسؤولية بموجب قانون المسؤولية عن المنتج.\n\n9. المصدر المفتوح\nقد يتم ترخيص بعض مكونات GaiaCom أو مكتباتها أو تطبيقات العميل بموجب تراخيص مفتوحة المصدر (مثل GPL وMIT وApache). تظل شروط الترخيص الخاصة بهذه المكونات غير متأثرة بشروط الاستخدام هذه ويمكن الاطلاع عليها في مستودعات التعليمات البرمجية المصدر المقابلة.\n\n10. مراقبة الصادرات والامتثال\nيدرك المستخدم أن برامج التشفير قد تخضع لضوابط التصدير الصارمة والقيود القانونية. يتحمل المستخدم مسؤولية ضمان أن استخدام GaiaCom لا ينتهك القوانين أو قيود الاستيراد/التصدير أو لوائح التشفير الخاصة ببلد إقامته.\n\n11. إشعار حماية البيانات (نسخة قصيرة للنسخة التجريبية)\n11.1. الحد الأدنى من جمع البيانات: كجزء من المرحلة التجريبية، يقوم الموفر فقط بجمع البيانات الضرورية للغاية للتشغيل الفني واستكشاف الأخطاء وإصلاحها ومواصلة التطوير (مثل ملفات سجل الخادم لتشخيص الأخطاء).\n11.2. لا توجد رؤية واضحة للمحتوى: بفضل المعرفة الصفرية المتسقة وتشفير E2E، لا يستطيع الموفر أبدًا الوصول إلى محتويات الدردشات أو رسائل البريد الإلكتروني أو المفاتيح المخزنة في GaiaVault.\n11.3. إعلان تفصيلي لحماية البيانات: ترتبط اللوائح التفصيلية لحماية البيانات بشكل منفصل ويجب أن يأخذها المستخدم أيضًا في الاعتبار قبل التسجيل.\n\n12. أحكام ختامية\n12.1. القانون المطبق: ينطبق قانون جمهورية ألمانيا الاتحادية، باستثناء اتفاقية الأمم المتحدة بشأن عقود البيع الدولي للبضائع.\n12.2. عرضة للتغيير: نظرًا لأن GaiaCom قيد التطوير النشط، يحتفظ المزود بالحق في تكييف هذه الشروط في أي وقت مع سريانه في المستقبل. الإصدار الحالي متاح في التطبيق.",
    "wizard_terms_title": "شروط استخدام GaiaCom واتفاقية الاختبار التجريبي (المرحلة التجريبية)",
    "node_operator": "مشغل العقدة",
    "search_channels": "بحث في القنوات...",
    "senior_reviewer": "كبار المراجعين",
    "trusted_reviewer": "مراجع موثوق",
    "active_frequencies": "الترددات النشطة",
    "connected_rooms": "مساحات متصلة",
    "dashboard": "لوحة القيادة",
    "empty_chats": "لا توجد محادثات نشطة متاحة.",
    "empty_messages": "لا توجد رسائل جديدة متاحة.",
    "encrypted": "مشفرة",
    "gaiacom_uplink": "جاياكوم الإرسال",
    "install_app": "تثبيت التطبيق",
    "install_app_desc": "لبدء سريع ووضع غير متصل بالشبكة",
    "kommandozentrale_alpha": "مركز قيادة ألفا",
    "network_online": "الشبكة: عبر الإنترنت",
    "new_room": "مساحة جديدة",
    "no_frequencies_active": "لا توجد ترددات نشطة. قم بإنشاء غرفة جديدة لبدء التواصل.",
    "no_id": "لا معرف",
    "open_chats": "فتح الدردشات",
    "open_inbox": "افتح البريد الوارد",
    "primary_identity": "الهوية الأساسية",
    "recent_chats": "محادثات جديدة",
    "recent_messages": "آخر الأخبار",
    "session_encrypted": "الجلسة مشفرة: {name}",
    "session_secure": "الحالة: آمن",
    "system_verlassen": "نظام الخروج",
    "write_message": "اكتب رسالة",
    "onboarding_step_profile": "الملف الشخصي",
    "onboarding_step_security": "الحماية",
    "onboarding_step_backup": "النسخ الاحتياطي",
    "onboarding_step_launch": "البدء",
    "onboarding_loading_gaia_id": "جاري تحميل معرف غايا",
    "onboarding_setup_kicker": "الإعداد الأولي لـ غاياكوم",
    "onboarding_profile_title": "اجعل غاياكوم مساحتك الخاصة.",
    "onboarding_profile_desc": "يظل اسم العرض والرمز التعبيري تحت التحكم المحلي ويمكن تغييرهما في الملف الشخصي في أي وقت.",
    "onboarding_security_title": "ما يحميه غاياكوم من أجلك الآن.",
    "onboarding_security_desc": "يفصل غاياكوم بين الهوية، والمفاتيح، والرسائل، وحالة الشبكة. ترى هنا فقط النسخة المختصرة للمستخدم.",
    "onboarding_backup_title": "النسخ الاحتياطي هو مخرج الطوارئ الحقيقي الخاص بك.",
    "onboarding_backup_desc": "بدون بيانات الاستعادة، لا يمكن لأحد إنقاذ هويتك. هذا هو بالضبط الهدف من الأمان الحقيقي من طرف إلى طرف.",
    "onboarding_launch_title": "جاهز. ماذا تريد أن تفعل أولاً؟",
    "onboarding_launch_desc": "يمكنك البدء مباشرة أو إنهاء الجولة والمتابعة في لوحة التحكم.",
    "onboarding_display_name": "اسم العرض",
    "onboarding_display_name_placeholder": "كيف تريد أن يعرضك غاياكوم؟",
    "onboarding_select_avatar": "اختر الرمز التعبيري",
    "onboarding_sec_identity_title": "الهوية",
    "onboarding_sec_identity_desc": "معرف غايا الخاص بك هو مرساة الشبكة الخاصة بك. يمكن لجهات الاتصال اكتشاف تغيير المفاتيح.",
    "onboarding_sec_messages_title": "الرسائل",
    "onboarding_sec_messages_desc": "يتم فك تشفير المحتوى محليًا. تتلقى الرسائل المعدلة تواقيع جديدة.",
    "onboarding_sec_network_title": "الشبكة",
    "onboarding_sec_network_desc": "يكشف مركز الأمان ومركز الإبلاغ عن المخاطر دون وجود أبواب خلفية عالمية.",
    "onboarding_sec_transparency_title": "الشفافية",
    "onboarding_sec_transparency_desc": "يسجل الأحداث الأمنية في البروتوكول لتبقي التحذيرات قابلة للتتبع.",
    "onboarding_backup_notice_title": "هام للمستخدمين العاديين",
    "onboarding_backup_notice_desc": "احفظ بيانات الاستعادة الخاصة بك بشكل منفصل عن هذا الجهاز. في حالة فقدان كلمة المرور والنسخ الاحتياطي، يظل غاياكوم مغلقًا عن قصد.",
    "onboarding_backup_consent": "أعلم أن نسختي الاحتياطية ضرورية للاستعادة وتغيير الجهاز.",
    "onboarding_inbox_title": "صندوق الوارد",
    "onboarding_inbox_desc": "قراءة الرسائل وكتابة أول رسالة لك.",
    "onboarding_contacts_title": "جهات الاتصال",
    "onboarding_contacts_desc": "التحقق من أول جهة اتصال أو بدء دردشة.",
    "onboarding_channels_title": "القنوات",
    "onboarding_channels_desc": "اكتشاف الترددات العامة.",
    "onboarding_security_title_card": "مركز الأمان",
    "onboarding_security_desc_card": "عرض حالة غاياشيلد.",
    "onboarding_later": "لاحقاً",
    "onboarding_back": "رجوع",
    "onboarding_continue": "متابعة",
    "onboarding_complete_setup": "إكمال الإعداد",
    "auth_legal_consent": "لقد قرأت وأوافق على سياسة الخصوصية وشروط الاستخدام.",
    "auth_show_terms": "عرض شروط الاستخدام",
    "auth_recovery_mode": "وضع الاسترداد",
    "auth_recovery_import_title": "استيراد ملف الاستعادة",
    "auth_recovery_import_desc": "استعد مفاتيح GaiaCom الخاصة بك من ملف نسخ احتياطي محمي بكلمة مرور. بعد ذلك، سيتم ملء العبارة التذكيرية واسم المستخدم مسبقاً.",
    "auth_recovery_file_pwd_placeholder": "كلمة مرور ملف الاستعادة",
    "auth_recovery_local_pwd_placeholder": "كلمة مرور محلي جديدة لفك القفل على الأقل ١٢ رمز",
    "auth_recovery_importing": "جاري الاستيراد...",
    "auth_recovery_decrypt": "فك تشفير الاستعادة",
    "auth_back_to_login": "الرجوع إلى تسجيل الدخول",
    "auth_terms_title": "شروط استخدام نسخة غاياكوم التجريبية",
    "auth_terms_close": "إغلاق",
    "auth_cookie_title": "غاياكوم يحافظ على سيادته.",
    "auth_cookie_desc": "نستخدم فقط التخزين المحلي الضروري تقنيًا للغة والجلسة والأمان. لا تتبع، ولا ملفات تعريف ارتباط إعلانية، ولا ملفات تعريف شخصية لطرف ثالث.",
    "auth_cookie_accept": "مفهوم",
    "sc_explainer_title": "ما هو المحمي هنا بالفعل؟",
    "sc_explainer_desc": "غاياشيلد هو طبقة الحماية بين حسابك ورسائلك والشبكة. لا يقرر بناءً على المحتوى، بل بناءً على المخاطر الفنية: التلاعب، محاولات إعادة التشغيل، الوصول غير المصرح به، أنماط تسجيل الدخول المشبوهة، وانتقالات البوابة غير الآمنة.",
    "sc_explainer_identity_desc": "يفحص حالات الشذوذ في تسجيل الدخول، ومخاطر الجلسة، والوصول إلى الهويات الأخرى.",
    "sc_explainer_messages_desc": "يكتشف أنماط إعادة التشغيل، والمغلفات المتلاعب بها، وغياب ميزات السلامة.",
    "sc_explainer_network_desc": "يحدد مخاطر الاتحاد، وحدود المعدل، وبروتوكول SMTP قبل أن تظهر الثقة بشكل خاطئ.",
    "sc_open_security_warnings": "التحذيرات الأمنية المفتوحة",
    "sc_opt_all": "الكل",
    "sc_opt_low": "منخفض",
    "sc_opt_medium": "متوسط",
    "sc_opt_high": "مرتفع",
    "sc_opt_critical": "حرج",
    "sc_opt_failed_login": "فشل تسجيل الدخول",
    "sc_opt_auth_attack": "هجوم المصادقة",
    "sc_opt_rate_limit": "حد الطلبات",
    "sc_opt_policy_violation": "ملاحظة السياسة",
    "sc_opt_message_replay": "إعادة تشغيل الرسالة",
    "sc_node_security_data_unavailable": "بيانات أمان العقدة غير متاحة",
    "sc_total_events": "إجمالي الأحداث",
    "sc_login_attacks": "هجمات تسجيل الدخول",
    "sc_rate_limits_active": "الحدود النشطة لطلبات المعالجة",
    "sc_smtp_shield_hits": "ضربات درع حماية SMTP",
    "sc_top_event_categories": "أهم فئات الأحداث",
    "sc_no_entries": "لا توجد مدخلات.",
    "sc_node_audit_log": "سجل تدقيق العقدة (الأحدث)",
    "sc_no_node_events": "لا توجد أحداث للعقدة.",
    "archiv": "الأرشيف",
    "entwuerfe": "المسودات",
    "markiert": "المميزة بنجمة",
    "wichtig": "هام",
    "snoozed": "المؤجلة",
    "papierkorb": "المهملات",
    "spam": "الرسائل غير المرغوب فيها",
    "cancel": "إلغاء",
    "error": "خطأ",
    "success": "نجاح",
    "kopieren": "نسخ",
    "block_contact": "حظر جهة الاتصال",
    "unblock_contact": "إلغاء حظر جهة الاتصال",
    "report_contact": "الإبلاغ عن جهة الاتصال",
    "check_fingerprint": "التحقق من البصمة",
    "export_encrypted": "تصدير (مشفر)",
    "export_gaiaproof": "تصدير (GaiaProof)",
    "export_password_prompt": "يرجى إدخال كلمة مرور لتشفير تصدير الدردشة:",
    "export_success": "تم تصدير الدردشة وتشفيرها بنجاح.",
    "export_failed": "فشل التصدير: ",
    "gaiaproof_export_success": "تم تصدير حزمة GaiaProof بنجاح.",
    "gaiaproof_export_failed": "فشل تصدير GaiaProof: ",
    "export_gaiaproof_confirm": "هل تريد تنزيل حزمة GaiaProof مع جميع التوقيعات وإيصالات تسليم الخادم؟ قد يستغرق هذا لحظة.",
    "group_settings_is_private": "غرفة خاصة (غير قابلة للبحث العام، طلبات الانضمام فقط)",
    "group_settings_read_only": "وضع القراءة فقط (يمكن للمالك والمسؤولين فقط إرسال الرسائل)",
    "group_settings_slow_mode": "الوضع البطيء (مهلة الإرسال)",
    "gsn_title": "خلاصة GSN الاجتماعية",
    "gsn_node_feed": "خلاصة العقدة",
    "gsn_following_feed": "المتابَعون",
    "gsn_feed_empty": "لم يتم العثور على منشورات.",
    "gsn_composer_placeholder": "ما الجديد في الاتحاد؟",
    "gsn_post_btn": "مشاركة",
    "gsn_profile": "ملف تعريف المستخدم",
    "gsn_followers": "المتابعون",
    "gsn_following": "المتابَعون",
    "gsn_bio": "الوصف / السيرة الذاتية:",
    "gsn_bio_label": "الوصف / السيرة الذاتية",
    "gsn_display_name": "اسم العرض",
    "gsn_edit_profile": "تعديل ملف التعريف",
    "gsn_save_profile": "حفظ",
    "gsn_add_image": "إضافة صورة (مشفرة)",
    "gsn_add_emoji": "إدراج رمز تعبيري",
    "gsn_avatar_emoji": "الصورة الرمزية (رمز تعبيري)",
    "gsn_follow": "متابعة",
    "gsn_unfollow": "إلغاء المتابعة",
    "gsn_repost": "مشاركة / إعادة نشر",
    "gsn_post_created": "تم مشاركة المنشور بنجاح.",
    "gsn_image_uploaded": "تم تشفير الصورة وتحميلها.",
    "gsn_upload_failed": "فشل تحميل الصورة: ",
    "gsn_comment_placeholder": "اكتب تعليقًا...",
    "gsn_delete_confirm_title": "حذف المنشور؟",
    "gsn_delete_confirm_desc": "هل أنت متأكد من أنك تريد حذف هذا المنشور نهائيًا؟",
    "gsn_delete_comment_confirm_title": "حذف التعليق؟",
    "gsn_delete_comment_confirm_desc": "هل أنت متأكد من أنك تريد حذف هذا التعليق نهائيًا؟",
    "gsn_report": "إبلاغ",
    "gsn_report_title": "الإبلاغ عن مخالفة",
    "gsn_report_category": "الفئة",
    "gsn_report_spam": "رسائل غير مرغوب فيها / إعلان",
    "gsn_report_harassment": "مضايقة / خطاب كراهية",
    "gsn_report_abuse": "إساءة استخدام",
    "gsn_report_illegal": "محتوى غير قانوني",
    "gsn_report_severity": "الخطورة",
    "gsn_report_low": "منخفض",
    "gsn_report_medium": "متوسط",
    "gsn_report_high": "مرتفع",
    "gsn_report_comment": "تعليق إضافي",
    "gsn_report_submit": "إبلاغ",
    "gsn_report_submitted": "تم تقديم البلاغ إلى إدارة الحوكمة.",
    "gsn_report_post": "الإبلاغ عن منشور",
    "report_group": "الإبلاغ عن المجموعة",
    "report_group_reason_prompt": "يرجى إدخال سبب الإبلاغ (اختياري):",
    "report_reason_prompt": "يرجى إدخال سبب الإبلاغ (اختياري):",
    "report_failed": "فشل الإبلاغ: ",
    "report_success": "تم الإبلاغ عن جهة الاتصال بنجاح.",
    "room_read_only_placeholder": "يمكن للمالك والمسؤولين فقط الكتابة",
    "read_only_active": "وضع القراءة فقط",
    "slow_mode_active": "الوضع البطيء نشط",
    "kommandozentrale": "مركز القيادة",
    "kontakt_blockiert": "تم حظر جهة الاتصال",
    "kontakt_freigegeben": "تم إلغاء حظر جهة الاتصال",
    "mailbox_settings_title": "إعدادات البريد",
    "mailbox_settings_desc": "إدارة التوقيع واللغة وتصفية البريد.",
    "mic_access_denied": "تم رفض الوصول إلى الميكروفون: ",
    "no_frequencies_active_desc": "أنشئ غرفة جديدة لبدء التواصل.",
    "key_changed_warning_title": "إشعار أمني:",
    "key_changed_warning_desc": "تم تحديث مفتاح هوية هذا المرسل أو يختلف عن المفتاح المعروف سابقًا. يرجى التحقق من البصمة عبر قناة آمنة أخرى.",
    "sc_col_category": "الفئة",
    "search_members": "البحث عن أعضاء...",
    "tab_general": "عام",
    "tab_members": "الأعضاء",
    "tab_requests": "الطلبات",
    "tab_invites": "الدعوات",
    "tab_logs": "السجلات",
    "auth_why_gaiacom": "لماذا GaiaCOM؟",
    "auth_why_gaiacom_desc": "البديل الآمن واللامركزي لاتصالاتك السرية.",
    "auth_self_managed_id": "معرف مدار ذاتياً",
    "auth_self_managed_id_desc": "أنشئ هويات مشفرة آمنة على الفور دون تقديم بريد إلكتروني أو رقم هاتف.",
    "auth_gaiadrop_secure_exchange": "تبادل آمن بدون حساب",
    "auth_gaiadrop_benefit_e2ee": "مشفر من الطرفين",
    "auth_gaiadrop_benefit_no_login": "لا يتطلب تسجيل الدخول",
    "auth_gaiadrop_benefit_inbox": "تسليم مباشر إلى صندوق وارد المستلم",
    "auth_terms_of_use": "شروط الاستخدام",
    "auth_terms_of_use_show": "عرض شروط الاستخدام",
    "auth_consent_privacy_terms": "لقد قرأت وأوافق على سياسة الخصوصية وشروط الاستخدام.",
    "auth_recovery_import_file": "استيراد ملف الاسترداد",
    "auth_recovery_password": "كلمة مرور ملف الاسترداد",
    "auth_recovery_local_password": "كلمة مرور فك قفل محلية جديدة لا تقل عن 12 رمزاً",
    "auth_recovery_decrypting": "فك تشفير الاسترداد...",
    "auth_recovery_back": "العودة إلى تسجيل الدخول",
    "auth_cookie_sovereign": "تبقى GaiaCOM ذات سيادة.",
    "auth_cookie_sovereign_desc": "نحن نستخدم فقط ميزات التخزين المحلي الضرورية من الناحية الفنية للغة والجلسة والأمان. لا تتبع، ولا ملفات تعريف ارتباط إعلانية، ولا ملفات تعريف شخصية لطرف ثالث.",
    "auth_cookie_sovereign_accept": "مفهوم",
    "unlock_keyboard_toggle": "⌨️ استخدام لوحة المفاتيح",
    "unlock_keypad_toggle": "🔢 استخدام لوحة PIN",
    "unlock_status_denied": "تم رفض الوصول / إعادة المحاولة",
    "unlock_status_decrypting": "فك تشفير الخزنة...",
    "unlock_status_secured": "الخزنة مؤمنة / مغلقة",
    "auth_landing_nav_legal": "قانوني",
    "auth_landing_nav_beta": "تجربة بيتا",
    "auth_landing_card1_title": "التشفير بعد الكمي (ML-KEM)",
    "auth_landing_card2_title": "لامركزي 100%",
    "auth_landing_card3_title": "المعرفة الصفرية",
    "auth_landing_card4_title": "حماية البيانات الوصفية",
    "auth_landing_card5_title": "معرف مدار ذاتيًا",
    "auth_landing_hybrid_title": "تشفير اليوم بالإضافة إلى الحماية ضد تهديدات الغد.",
    "auth_landing_hybrid_desc": "يجمع GaiaCom بين تبادل المفاتيح الكلاسيكي المثبت وتغليف المفاتيح بعد الكمي. دفاع في العمق.",
    "auth_landing_x25519_desc": "تبادل مفاتيح سريع ومثبت للمنحنيات الإهليلجية للأجهزة الحالية والجلسات الآمنة.",
    "auth_landing_mlkem_desc": "تغليف المفاتيح بعد الكمي للحفاظ على السرية طويلة المدى ضد سيناريوهات فك التشفير اللاحق.",
    "auth_landing_cycle_title": "الخادم لا يرى شيئًا. الشبكة تنقل الضوضاء فقط.",
    "auth_landing_step1_title": "التشفير المحلي",
    "auth_landing_step1_desc": "يتم تشفير الرسالة على جهاز المرسل قبل أن تصل إلى الشبكة أو الخادم.",
    "auth_landing_step2_title": "النقل ككتلة بيانات (Blob)",
    "auth_landing_step2_desc": "تسافر الحزمة كضوضاء تشفير عبر العقد الفيدرالية أو طبقات التخزين اللامركزية.",
    "auth_landing_step3_title": "التخزين الفيدرالي",
    "auth_landing_step3_desc": "لا يوجد صندوق بريد مركزي كهدف. البيانات مجزأة وفيدرالية ومشفرة بالكامل.",
    "auth_landing_step4_title": "فك التشفير المحلي",
    "auth_landing_step4_desc": "فقط المفتاح الخاص بالمستلم يمكنه تحويل الكتلة المشفرة مرة أخرى إلى محتوى مقروء.",
    "auth_landing_trinity_title": "مفهوم بروتوكول واحد. ثلاثة مستويات للبنية التحتية.",
    "auth_landing_enterprise_desc": "للشركات، ومكاتب المحاماة، والمؤسسات المتوسطة، والصناعة، والخدمات المصرفية الخاصة. دوائر اتصال مغلقة مع تحكم إداري ودعم.",
    "auth_landing_enterprise_list1": "السيادة الداخلية وإدارة المستخدمين",
    "auth_landing_enterprise_list2": "عقدة مستضافة ذاتيًا أو مجموعة سيادية مدارة",
    "auth_landing_enterprise_list3": "اتفاقية مستوى الخدمة والدعم والوحدات المتميزة",
    "auth_landing_network_desc": "الشبكة المفتوحة للخصوصية الرقمية. لا توجد تجارة بيانات، بل بنية تحتية للاتصالات الحرة والمشفرة.",
    "auth_landing_network_list1": "تطبيق عميل مفتوح المصدر",
    "auth_landing_network_list2": "عقد فيدرالية",
    "auth_landing_network_list3": "بدون مفتاح فك تشفير مركزي",
    "auth_landing_defend_desc": "بنية تحتية مخصصة وعالية الأمان للسلطات والبنى التحتية الحيوية وصوامع الاتصالات المعزولة.",
    "auth_landing_defend_list1": "عمليات نشر معزولة تمامًا عن الإنترنت (air-gapped)",
    "auth_landing_defend_list2": "العلامة البيضاء وتدقيق الكود المصدري",
    "auth_landing_defend_list3": "السيادة الرقمية الوطنية",
    "auth_landing_gov_title": "بروتوكول مفتوح. تنفيذ تجاري. فصل قانوني واضح.",
    "auth_landing_gov_desc": "يفصل GaiaCom بين البروتوكول المفتوح والعملاء المفتوحين والبنية التحتية التجارية المتميزة. تأتي الثقة من الشفافية؛ والإيرادات من دعم المؤسسات والوحدات الخاصة.",
    "auth_landing_price1_desc": "رسوم حماية من البوتات للتوزيع على متاجر التطبيقات.",
    "auth_landing_price2_desc": "مفتوح المصدر ومجاني للمستخدمين الذين يفضلون تجميع الكود بأنفسهم.",
    "auth_landing_price3_desc": "للمؤسسات متوسطة الحجم، ومكاتب المحاماة، والفرق الحساسة.",
    "auth_landing_price4_desc": "للشركات الكبرى، والمجموعات عالية التوفر، ودليل LDAP، ووصول المسؤول الرئيسي.",
    "auth_landing_license1_desc": "أقصى قدر من شفافية الكود للمستخدمين وعمليات التدقيق المجتمعية.",
    "auth_landing_license2_desc": "حماية الحقوق المتروكة ضد الاستيلاء السحابي وفروع البروتوكول المغلقة.",
    "auth_landing_license3_desc": "وصول المسؤول الرئيسي، وتدقيق الأمان، واتفاقية مستوى الخدمة، ومنطق الأعمال المخصص.",
    "auth_landing_final_title": "نموذج اتصال قائم على انعدام الثقة.",
    "auth_landing_final_desc": "لا يحل GaiaCom محل البريد الإلكتروني ببساطة. إنه يطرح التساؤل حول سبب استمرار اعتماد الاتصالات الحساسة على خوادم يمكن قراءتها وافتراضات قديمة تعود إلى 40 عامًا.",
    "auth_landing_final_note": "ملاحظة: تصف هذه الصفحة مفهومًا للبنية التحتية وخارطة طريق. يجب تأكيد وعود الأمان من خلال التدقيق الفعلي قبل التشغيل الفعلي."




  };

export default ar;